// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_AT_RULE_IMPORT_0___ = require("-!../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[6].rules[0].oneOf[1].use[0]!../../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[6].rules[0].oneOf[1].use[1]!../../../../assets/theme/css/dashboard.css");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sym-doughnut-chart {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.sym-doughnut-chart canvas {
  width: auto;
  height: auto;
  max-width: 550px;
  max-height: 150px;
}
.sym-doughnut-chart h4 {
  margin-bottom: 15px;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/app/dashboard/Dashboards/doughnutChart/doughnutChart.component.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AAAF;AAEE;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;AAAJ;AAGE;EACE,mBAAA;EACA,kBAAA;AADJ","sourcesContent":["@import '../../../../assets/theme/css/dashboard.css';\n\n.sym-doughnut-chart {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n\n  canvas {\n    width: auto;\n    height: auto;\n    max-width: 550px;\n    max-height: 150px;\n  }\n\n  h4 {\n    margin-bottom: 15px;\n    text-align: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
